export default "__VITE_ASSET__D412075h__"